// localStorage can be unavailable or throw (disabled storage, quota, some
// private modes). Every access is guarded so the widget keeps working with
// empty values; the server remains authoritative for everything stored here.
export class LocalStorageManager {
    get(key) {
        try {
            return JSON.parse(localStorage.getItem(key));
        } catch {
            return null;
        }
    }

    set(key, value) {
        if (typeof value === 'string' && value.trim().startsWith('{')) {
            try {
                value = JSON.parse(value);
            } catch {
                // keep as string
            }
        }

        try {
            localStorage.setItem(key, JSON.stringify(value));
        } catch {
            // Storage unavailable or full: nothing persisted
        }
    }

    remove(key) {
        try {
            localStorage.removeItem(key);
        } catch {
            // Storage unavailable
        }
    }
}
